import React, { useEffect, useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { useLocation, useNavigate } from "react-router-dom";
import Gift from "./Gift";
import SpinWheelForm from "./SpinWheelForm";
import SpinWheelService from "../../Services/SpinWheelService";
import { showErrorToast, showSuccessToast } from "../../Constant/Notification";
import { ToastContainer } from "react-toastify";
import GiftEditor from "./GiftEditor";
import SpinWheelFormEditor from "./SpinWheelFormEditor";

const SpinWheelEditor = () => {
  const [spObj, setSpObj] = useState(null); // For Spin Wheel Details
  const [gifts, setGifts] = useState([]); // For Gift Details

  const navigate = useNavigate();
  const location = useLocation();

  // Retrieve existing data from location state (or load via API if needed)
  console.log(location.state.docId)
  const existingSpinWheel = location.state?.spinWheelData.spinWheel || null;
  const existingGifts = location.state?.spinWheelData?.gifts || null;
console.log(existingSpinWheel)
  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userUid = userObj?.user?.uid;

  const createdUserDocId= userUid;
  const modifiedUserDocId = userUid

  // Prepopulate data when editing an existing spin wheel
  useEffect(() => {
    if (existingSpinWheel) {
      setSpObj(existingSpinWheel);
    }
    if (existingGifts) {
      setGifts(existingGifts);
    }
  }, [existingSpinWheel, existingGifts]);
  const docId= location.state.docId

  const handleUpdate = async () => {
    if (!gifts || !spObj) {
      showErrorToast("All Fields are mandatory");
      return false;
    }

    try {
      const response = await SpinWheelService.updateSpinWheel(
        docId,
        spObj,
        gifts,
        modifiedUserDocId,
      );
      console.log(response.data);
      navigate(-1, { state: { message: "Spin Wheel updated successfully" } });
    } catch (error) {
      showErrorToast(error.response?.data || "Error updating spin wheel");
      console.error(error.response?.data || error.message);
    }
  };
console.log(gifts)
  const handleBack = () => {
    navigate(-1);
  };

  const updateGiftsDetail = (updatedGifts) => {
    setGifts(updatedGifts);
  };

  const handleSpinWheelData = (sp) => {
    setSpObj(sp);
  };

  return (
    <div className=" bg-appGrayBackground pb-20">
      <AdminAppBar />
      <ToastContainer />
      <div className="pt-24 px-20 xl:px-6 relative flex justify-between gap-5">
        <div className="flex gap-6">
          <svg
            onClick={handleBack}
            className="cursor-pointer"
            width="20"
            height="34"
            viewBox="0 0 22 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
              fill="#399E79"
            />
          </svg>
          <div>
            <h1 className="text-4xl font-semibold whitespace-nowrap">
              Edit Spin Wheel
            </h1>
          </div>
        </div>
        <div>
          <button
            onClick={handleUpdate}
            className="whitespace-nowrap bg-customGreen rounded-lg p-1 px-5 w-32 text-lg text-white h-10 text-center"
          >
            Update
          </button>
        </div>
      </div>
      <div className="mt-5 mx-10 flex gap-10">
        <div className="w-8/12 bg-white rounded-lg px-5 py-5">
          <GiftEditor  updateGiftsDetail={updateGiftsDetail} initialGifts={existingGifts} />
        </div>
        <div className="w-4/12 bg-white rounded-lg px-5">
          <SpinWheelFormEditor spDetail={handleSpinWheelData} initialSpinWheel={existingSpinWheel} />
        </div>
      </div>
    </div>
  );
};

export default SpinWheelEditor;
